import request from '@/utils/request'

const api = {
  patentList: '/patent/patent/listJson',
  patentDetail: '/patent/patent/get',
  search: '/patent/patent/search', // 高级检索
  getAllCollegeApplicant: '/patent/statistics/getAllCollegeApplicant', // 获取所有高校
  getConversionByDate: '/patent/statistics/getConversionByDate', // 统计分析 - 中国专利 转化情况分析
  getTotalByDate: '/patent/statistics/getTotalByDate', // 统计分析 - 专利申请 总量分析
  getYearByDate: '/patent/statistics/getYearByDate', // 统计分析 - 专利申请 趋势分析
  getTypeByDate: '/patent/statistics/getTypeByDate', // 统计分析 - 中国专利 类型分析
  getIpcType1: '/patent/statistics/getIpcType1',
  getIpcType2: '/patent/statistics/getIpcType2',
  getIpcType3: '/patent/statistics/getIpcType3',
  getIpcType4: '/patent/statistics/getIpcType4',
  getIpcType5: '/patent/statistics/getIpcType5',
}

export default api

export function getPatentList(parameter) {
  return request({
    url: api.patentList,
    method: 'get',
    params: parameter
  })
}

export function getMonthlyPatentList(parameter) { // 首页获取转化专利列表
  return request({
    url: api.patentList,
    method: 'post',
    data: parameter,
    headers: {"Content-Type": "multipart/form-data; boundary=--------------------------196735600174582558462189"}
  })
}

export function getPatentDetail(parameter) {
  return request({
    url: api.patentDetail,
    method: 'get',
    params: parameter
  })
}

export function patentSearch(data) {
  return request({
    url: api.search,
    method: 'post',
    data: data
  })
}

export function getAllCollegeApplicant() {
  return request({
    url: api.getAllCollegeApplicant,
    method: 'get',
  })
}

export function getConversionByDate(parameter) {
  return request({
    url: api.getConversionByDate,
    method: 'post',
    params: parameter
  })
}

export function getTotalByDate(parameter) {
  return request({
    url: api.getTotalByDate,
    method: 'post',
    params: parameter
  })
}

export function getYearByDate(parameter) {
  return request({
    url: api.getYearByDate,
    method: 'post',
    params: parameter
  })
}

export function getTypeByDate(parameter) {
  return request({
    url: api.getTypeByDate,
    method: 'post',
    params: parameter
  })
}

export const getIpcTypeFunctions = {

  getIpcType1: function (parameter) {
    return request({
      url: api.getIpcType1,
      method: 'post',
      params: parameter
    })
  },
  getIpcType2: function (parameter) {
    return request({
      url: api.getIpcType2,
      method: 'post',
      params: parameter
    })
  },
  getIpcType3: function (parameter) {
    return request({
      url: api.getIpcType3,
      method: 'post',
      params: parameter
    })
  },
  getIpcType4: function (parameter) {
    return request({
      url: api.getIpcType4,
      method: 'post',
      params: parameter
    })
  },
  getIpcType5: function (parameter) {
    return request({
      url: api.getIpcType5,
      method: 'post',
      params: parameter
    })
  }
}

// mobileCode

// export function getIpcType1(parameter) {
//   return request({
//     url: api.getIpcType1,
//     method: 'post',
//     params: parameter
//   })
// }

// export function getIpcType2(parameter) {
//   return request({
//     url: api.getIpcType2,
//     method: 'post',
//     params: parameter
//   })
// }

// export function getIpcType3(parameter) {
//   return request({
//     url: api.getIpcType3,
//     method: 'post',
//     params: parameter
//   })
// }

// export function getIpcType4(parameter) {
//   return request({
//     url: api.getIpcType4,
//     method: 'post',
//     params: parameter
//   })
// }

// export function getIpcType5(parameter) {
//   return request({
//     url: api.getIpcType5,
//     method: 'post',
//     params: parameter
//   })
// }

export function getRoleList(parameter) {
  return request({
    url: api.role,
    method: 'get',
    params: parameter
  })
}

export function getServiceList(parameter) {
  return request({
    url: api.service,
    method: 'get',
    params: parameter
  })
}

export function getPermissions(parameter) {
  return request({
    url: api.permissionNoPager,
    method: 'get',
    params: parameter
  })
}

export function getOrgTree(parameter) {
  return request({
    url: api.orgTree,
    method: 'get',
    params: parameter
  })
}

// id == 0 add     post
// id != 0 update  put
export function saveService(parameter) {
  return request({
    url: api.service,
    method: parameter.id === 0 ? 'post' : 'put',
    data: parameter
  })
}

export function saveSub(sub) {
  return request({
    url: '/sub',
    method: sub.id === 0 ? 'post' : 'put',
    data: sub
  })
}
